// emorpi kesintisiz liste: koleksiyon sayfasında "2. sayfa" yerine müşteri aşağı indikçe sıradaki sayfanın ürünleri
// aynı ızgaraya eklenir. Sayfa bağlantıları HTML'de kalır (arama motorları ve JS'siz tarayıcılar için), yalnızca gizlenir.
// Filtre/sıralama ızgarayı yeniden çizince baştan kurulur.
(() => {
  if (window.emorpiSonsuz) return;
  window.emorpiSonsuz = true;

  let state = null;

  const nextUrl = (wrapper) => {
    if (!wrapper) return null;
    const page = parseInt(wrapper.dataset.page, 10) || 1;
    const link = [...wrapper.querySelectorAll('a[href]')].find((a) => {
      const url = new URL(a.href, location.href);
      return parseInt(url.searchParams.get('page'), 10) === page + 1;
    });
    return link ? link.href : null;
  };

  const setup = () => {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id) return;
    if (state && state.grid === grid) return;
    if (state) state.stop();

    const wrapper = grid.closest('#ProductGridContainer')?.querySelector('.pagination-wrapper') || document.querySelector('.pagination-wrapper');
    let url = nextUrl(wrapper);
    if (!url) return;
    wrapper.hidden = true;

    const status = document.createElement('div');
    status.className = 'e-sonsuz';
    status.setAttribute('role', 'status');
    status.innerHTML = '<span class="e-sonsuz__spin" aria-hidden="true"></span><span class="visually-hidden">Ürünler yükleniyor</span>';
    grid.after(status);

    let busy = false;
    const load = async () => {
      if (busy || !url) return;
      busy = true;
      status.classList.add('is-loading');
      try {
        const u = new URL(url, location.href);
        u.searchParams.set('section_id', grid.dataset.id);
        const html = await fetch(u).then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        });
        if (state?.grid !== grid) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = [...doc.querySelectorAll('#product-grid > li')];
        // Kaydırınca beliren Dawn animasyonu: yeni kartlar da aynı şekilde gelsin
        items.forEach((li) => grid.appendChild(document.adoptNode(li)));
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
        else grid.querySelectorAll('.scroll-trigger--offscreen').forEach((el) => el.classList.remove('scroll-trigger--offscreen'));
        url = items.length ? nextUrl(doc.querySelector('.pagination-wrapper')) : null;
      } catch (e) {
        // Yüklenemedi: sayfa bağlantılarını geri göster, müşteri elle geçebilsin
        url = null;
        wrapper.hidden = false;
      }
      status.classList.remove('is-loading');
      busy = false;
      if (!url) {
        state?.stop();
        status.remove();
      } else if (status.getBoundingClientRect().top < window.innerHeight + 1200) {
        // Ekran hâlâ dolmadıysa (büyük ekran) bir sonrakini de getir
        load();
      }
    };

    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) load();
    }, { rootMargin: '0px 0px 1200px 0px' });
    io.observe(status);
    // Yedek: gözlemcinin geç kaldığı tarayıcılarda kaydırmada da bak
    let timer = 0;
    const onScroll = () => {
      if (timer) return;
      timer = setTimeout(() => {
        timer = 0;
        if (status.isConnected && status.getBoundingClientRect().top < window.innerHeight + 1200) load();
      }, 150);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    state = {
      grid,
      stop: () => {
        io.disconnect();
        window.removeEventListener('scroll', onScroll);
      },
    };
  };

  const start = () => {
    setup();
    // Filtre ve sıralama ızgara kabını yeniden çizer
    const container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(setup).observe(container.parentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
